<template>
  <div class="print-table-head" :style="heandStyle">
    <div class="print-table-head__title">
      {{title}}
    </div>
    <div class="print-table-head__info">
      <div class="print-table-head__info-item">
        <div>系列：{{group||''}}</div>
        <div>波段：{{italyWaveCode||''}}</div>
        <div>面料：{{plus}}</div>
        <div>款号：{{materialCode}}</div>
      </div>
      <div class="print-table-head__info-item">
        <div>款式：{{valueDesc}}</div>
        <div v-if="brand=='6'">意大利款号：{{italyMaterialCode}}</div>
        <div>名称：{{materialDescCn}}</div>
        <div>打印日期：{{currentDate}}</div>
      </div>
    </div>
    <div class="print-table-head__img">
      <img
        :src="img"
        class="bom-image">
    </div>
    <div class="print-table-head__remark">关联款号：{{innerRemark}}</div>
  </div>
</template>

<script>
  export default {
    name: 'table-head',
    props: ['brand','italyWaveCode','italyMaterialCode','title', 'group', 'series', 'plus', 'materialCode', 'currentDate', 'valueDesc', 'materialDescCn', 'img', 'innerRemark'],
    methods: {

    },
    data() {
      return {
      }
    },
    computed:{
      heandStyle(){
        return {
           height: '31mm'
        }
      }
    }
  }
</script>

<style>
</style>
